i<template>
	<div id="wrapper" class="container">
	    <div>
	        <div style="font-size:0.28rem;color:#676f81;padding: .86rem 0 .54rem 0;text-align: center;line-height: 1.1;">为确保是您本人操作，请完成以下验证</div>
	        <div style="font-size:0.32rem;text-align: center;line-height: 1.1;">我们已经发送了验证码到您的手机：</div>
	        <div style="font-size:0.32rem;padding: 0.2rem 0 .78rem 0;text-align: center;line-height: 1.1;">{{phoneStr}}</div>
	        <div class="code-box">
	            <label>验证码</label>
	            <input name="code" v-model="code" type="tel" placeholder="短信验证码" maxlength="6" οninput="if(value.length>6)value=value.slice(0,6)">
	            <div class="btn-code" @click="sendCode()">{{numsStr}}</div>
	        </div>
	        <span id="btn_next" class="btn btn-gray btn-l" @click="validate()">下一步</span>
	    </div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				telReg : /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/,
				numsStr:"再次获取(60秒)",
				nums:60,
				clock:'',
				isClick:false,
				phone:'',
				phoneStr:'',
				code:'',
			}
		},
		methods:{
			upNmuber:function(){
				var _this = this;
				this.clock = setInterval(function(){
					_this.nums--;	
					if(_this.nums > 0){
						_this.numsStr = "再次获取("+_this.nums+"秒)"
					}else{
						_this.isClick = false;
						_this.nums = 60; //重置时间
						_this.numsStr = "再次获取";
						clearInterval(_this.clock); //清除js定时器
					}
				}, 1000); //一秒执行一次
			},
			validate:function(){
				var _this = this;
				if('' == this.code){
					return weui.alert("验证码不能为空");
				}
				 _this.$axios.post(_this.stuApiUrl + "/student/modify-phone",
				 _this.$qs.stringify({code:_this.code,phone:_this.phone}))
                .then(function (response) {
                	if(response.data.success){
                		_this.$router.replace('/student/user/phone-succeed');
                		clearInterval(_this.clock);
					}else{
						weui.alert(response.data.info);
					}
                }).catch(function (error) {
                    console.log(error);
                });
			},
			sendCode:function(){
				var _this = this;
				if (!this.telReg.test(this.phone)) {
					return weui.alert("手机号格式错误");
				}

             	if(this.isClick){
                	return;
              	}
                this.isClick = true;
				this.upNmuber();
                _this.$axios.post(_this.stuApiUrl + "/student/stu-wechat-message",_this.$qs.stringify({phone:_this.phone}))
                .then(function (response) {
                	if(response.data.success){
						weui.toast('验证码发送成功');
					}else{
						weui.alert("发送失败");
					}
                }).catch(function (error) {
                    console.log(error);
                });
            },
		},
		mounted(){
			this.phone = this.$route.params.phone;
			if(this.phone != 'unset'){
				var _this = this;
				this.phoneStr = this.phone.substr(0,parseInt(this.phone.split('').length/3))
								+'****'+this.phone.substr(parseInt(this.phone.split('').length/2+2),this.phone.split('').length);
				this.sendCode();
			}
			
		},
		beforeDestroy(){
		},
		destroyed(){
			clearInterval(this.clock);
		}
	}
</script>

<style scoped>
@import '../../../../static/css/student/user/validate-new-phone.css';
</style>



// WEBPACK FOOTER //
// src/components/student/user/validate-new-phone.vue